import {Mutation, Query} from 'react-apollo';
import {Redirect} from 'react-router-dom';
import React, {Component, Fragment} from 'react';
import styled from 'styled-components';

import DescriptionModal from './DescriptionModal';
import Error from '../settings/Error';
import FavoritePageIndicator from './FavoritePageIndicator';
import Info from '../common/card-grid/Info';
import Loading from '../settings/Loading';
import NextPageButton from '../common/NextPageButton';
import PagingRouter from '../common/PagingRouter';
import ReportCardGrid from '../common/card-grid/ReportCardGrid';
import addFavoriteMutation from './addFavoriteMutation';
import addFavoritePageQuery from './addFavoritePageQuery';
import getPeriodAnchor from '../../utils/getPeriodAnchor';

const FullInfo = styled(Info)`
  background-color: ${({theme}) => theme.red}40;
`;

const getInitialState = () => ({
  type: null,
  page: null,
  index: null,
  modalVisible: false,
});

class AddFavorite extends Component {
  state = getInitialState();

  showDescriptionModal = ({type, page, index}) => {
    this.setState({type, page, index, modalVisible: true});
  };

  save = description => {
    const {type, page, index} = this.state;
    const {addFavorite, showFavoritePage} = this.props;
    addFavorite({variables: {input: {type, page, index, favoriteDesc: description}}}).then(() => {
      this.setState(getInitialState());
      showFavoritePage(page);
    });
  };

  cancel = () => {
    this.setState(getInitialState());
  };

  render() {
    const {page, type, total, totalPages, hasNextPage, showNextPage} = this.props;
    const places = [];
    if (total === 6) {
      places.push(<FullInfo key="full">Seite {page + 1} ist bereits voll.</FullInfo>);
    } else {
      for (let i = 0; i <= total; i++) {
        const onClick = () => {
          this.showDescriptionModal({type, page, index: i});
        };
        places.push(
          <Info key={`${page}-${i}`} onClick={onClick}>
            Platz {i + 1}
          </Info>
        );
      }
    }
    return (
      <Fragment>
        <DescriptionModal isVisible={this.state.modalVisible} save={this.save} cancel={this.cancel} />
        <ReportCardGrid>{places}</ReportCardGrid>
        <NextPageButton hide={!hasNextPage} onClick={showNextPage} />
        <FavoritePageIndicator>
          Seite {page + 1} / {totalPages}
        </FavoritePageIndicator>
      </Fragment>
    );
  }
}

class AddFavoritePage extends Component {
  render() {
    const {match, getPageUrl, history} = this.props;
    const {page, type} = match.params;
    const pageNum = parseInt(page, 10);
    const variables = {
      input: {filter: {offset: pageNum, limit: 1}},
      reportInput: {periodAnchor: getPeriodAnchor()},
    };
    return (
      <Query query={addFavoritePageQuery} variables={variables} fetchPolicy="network-only">
        {({loading, error, data}) => {
          if (loading) return <Loading />;
          if (error) return <Error error={error} />;
          const {pages, total} = data.favoritePages;
          // fakes one additional page
          const hasNextPage = pageNum < total;
          if (pageNum !== 0 && pageNum > total) return <Redirect to={getPageUrl(0)} />;

          const totalFavorites = pages.length ? pages[0].total : 0;
          return (
            <Mutation mutation={addFavoriteMutation}>
              {(addFavorite, {loading}) =>
                loading ? (
                  <Loading />
                ) : (
                  <AddFavorite
                    match={match}
                    total={totalFavorites}
                    totalPages={total + 1}
                    page={pageNum}
                    type={type}
                    hasNextPage={pageNum !== 0 || hasNextPage}
                    showFavoritePage={page => history.push(`/favorites/${page}`)}
                    showNextPage={() => history.push(getPageUrl(hasNextPage ? pageNum + 1 : 0))}
                    addFavorite={addFavorite}
                  />
                )
              }
            </Mutation>
          );
        }}
      </Query>
    );
  }
}

export default PagingRouter(AddFavoritePage);
